import React, { useState, useEffect } from 'react';
import { Alert, Col, Row, Table } from 'react-bootstrap';
import '../../../styles/RegDashboard.css';
import { AdditionalServicesModal } from './Modals/AdditionalServicesModal';
import { CancelSubscriptions } from './Modals/CancelSubscriptions';
import { ContentBox } from './utility/ContentBox';
import { ContentItem } from './utility/ContentItem';
import { ContentTitle } from './utility/ContentTitle';
import { ServicesAndSolutionsAlert } from './ServicesAndSolutionsAlert';
import { HelpAlert } from '../../utility/HelpAlert';

export function ServicesAndSolutions(props) {
    const [account, setAccount] = useState(props.account);
    const [user, setUser] = useState(props.user);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (props.account && props.user) {
            setAccount(props.account);
            setUser(props.user);
            setLoading(false);
        }
    }, [props]);


    const currentServices = () => {
        var services = "";

        if (account.registrationType && account.registrationType !== "") {
            services = account.registrationType + ";";
        }
            if (account.chr && !services.includes("CHR")) services += "CHR;";
            if (account.dsm && !services.includes("DSM")) services += "DSM;";
            if (account.referrals && !services.includes("Referrals")) services += "Referrals;";
            if (account.notify && !services.includes("Notify")) services += "Notify;";
            if (services.length > 0) {
                services = services.slice(0, -1);
            }
        return services.replace(/;/g, "; ");
    }

    const remainingChrProviders = () => {
        var chrProviders = account.members.filter(member => {
            var result;
            if (member.passStatus.type === "Provider" && member.chr) {
                result = true;
            }
            else { result = false }
            return result;
        })
        return (parseInt(account.chrProviderLimit) - chrProviders.length);
    }

    const remainingChrStaff = () => {
        var chrStaff = account.members.filter(member => {
            var result;
            if (member.passStatus.type !== "Provider" && member.chr) {
                result = true;
            }
            else { result = false }
            return result;
        })
        return (parseInt(account.chrStaffLimit) - chrStaff.length);
    }

    const remainingNotifyProviders = () => {
        var notifyProviders = account.members.filter(member => {
            var result;
            if (member.passStatus.type === "Provider" && member.notify) {
                result = true;
            }
            else { result = false }
            return result;
        })
        return (parseInt(account.notifyProviderLimit) - notifyProviders.length);
    }

    const remainingNotifyStaff = () => {
        var notifyStaff = account.members.filter(member => {
            var result;
            if (member.passStatus.type !== "Provider" && member.notify) {
                result = true;
            }
            else { result = false }
            return result;
        })
        return (parseInt(account.notifyStaffLimit) - notifyStaff.length);
    }



    return (
        <ContentBox>
            {!loading &&
                <>
                    <Row>
                        <ContentTitle
                            position="left"
                            title="Services and Solutions"
                        />

                    </Row>
                    <Row>
                        <ContentItem
                            position="left"
                            label="Current Services and Solutions"
                            content={<div id="account-services">{currentServices()}</div>}
                        />
                        <Col>
                            <AdditionalServicesModal
                                account={props.account}
                                user={user}
                            />
                            <CancelSubscriptions
                                account={props.account}
                                user={user}
                            />
                        </Col>
                    </Row>
                    <br />
                <HelpAlert user={user} account={account} />
                    <br />
                    <Row>
                        {currentServices().includes("CHR") &&
                            <>
                                {account.chrIsLimited ?
                                    <ContentItem
                                        position="left"
                                        content={
                                            <Table
                                                id="chr-services-table"
                                                variant="light"
                                                striped
                                                hover
                                                bordered
                                            >
                                                <thead>
                                                    <tr>
                                                        <th>Health eNet Services</th>
                                                        <th>(CHR)</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <th></th>
                                                        <th>Providers</th>
                                                        <th>Staff</th>
                                                    </tr>
                                                    <tr>
                                                        <th>Maximum</th>
                                                        <td>{account.chrProviderLimit}</td>
                                                        <td>{account.chrStaffLimit}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Remaining</th>
                                                        <td>{remainingChrProviders()}</td>
                                                        <td>{remainingChrStaff()}</td>
                                                    </tr>
                                                </tbody>
                                            </Table>}
                                    />
                                    :
                                    <ContentItem
                                        position="left"
                                        label="CHR Personel Limit"
                                        content={"Unlimited CHR Users"}
                                    />
                                }
                            </>
                        }
                        {currentServices().includes("Notify") &&
                            <>
                                {account.notifyIsLimited ?
                                    <ContentItem
                                        position="right"
                                        content={
                                            <Table
                                                id="notify-services-table"
                                                variant="light"
                                                striped
                                                hover
                                                bordered
                                            >
                                                <thead>
                                                    <tr>
                                                        <th>Notify Services</th>
                                                        <th></th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <th></th>
                                                        <th>Providers</th>
                                                        <th>Staff</th>
                                                    </tr>
                                                    <tr>
                                                        <th>Maximum</th>
                                                        <td>{account.notifyProviderLimit}</td>
                                                        <td>{account.notifyStaffLimit}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Remaining</th>
                                                        <td>{remainingNotifyProviders()}</td>
                                                        <td>{remainingNotifyStaff()}</td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        }
                                    />
                                    :
                                    <ContentItem
                                        position="right"
                                        label="Notify Personel Limit"
                                        content={"Unlimited Notify Users"}
                                    />
                                }
                            </>
                        }
                    </Row>
                    <ServicesAndSolutionsAlert account={account} user={user} />
                </>
            }

        </ContentBox>
    );
}
